import { Badge, Box } from "@mui/material";
import { FC, useEffect, useState } from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useDrawerContext } from "../../../contexts/DrawerContext";
import DrawerBox from "../../UI/DrawerBox";
import WorkflowTaskShort from "../../../pages/WorkflowTasks/WorkflowTaskShort";
import { useAuth } from "../../../hooks/useAuth";

import { collection, onSnapshot, query, where } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { firebase } from "../../../utils/firebase";
import { RightSideBarStyles } from "../sidemenu/styles";
import FlexBox from "../../FlexBox";

const WorkflowTaskNotifications: FC = () => {
  const { user, fbtoken }: any = useAuth();
  const { showDrawer, setShowDrawer, setDrawerId } = useDrawerContext();
  const [taskCount, setTaskCount] = useState(0);

  useEffect(() => {
    let unsubscribe: any;

    const initFirebase = async () => {
      if (user?.uid) {
        try {
          unsubscribe = onSnapshot(
            query(
              collection(
                getFirestore(firebase),
                `${process.env.REACT_APP_FIRESTORE_NOTIFICATION_COLLECTION}/${user.uid}/${process.env.REACT_APP_FIRESTORE_SUB_COLLECTION_TASKS}`,
              ),
              where("status", "==", 0),
            ),
            (collection) => {
              setTaskCount(collection.docs.length);
            },
          );
        } catch (error) {}
      }
    };

    if (fbtoken) {
      initFirebase();
    }

    return () => unsubscribe && unsubscribe();
  }, [user?.uid, user.type, fbtoken]);

  const handleOpenDrawer = () => {
    setDrawerId("workflow-tasks");
    setShowDrawer({ ...showDrawer, ...{ right: true } });
  };

  const closeDrawer = () => {
    setShowDrawer({ ...showDrawer, ...{ right: false } });
  };

  return (
    <>
      <FlexBox
        justifyContent={"center"}
        flexDirection={"column"}
        alignItems={"center"}
        onClick={handleOpenDrawer}
      >
        <Box
          sx={{ ...RightSideBarStyles.iconWrapper, background: "#FF8012" }}
          onClick={handleOpenDrawer}
        >
          <Badge color="error" badgeContent={taskCount}>
            <TaskAltIcon />
          </Badge>
        </Box>
        <Box sx={{ ...RightSideBarStyles.label }} className="label">
          Approvals
        </Box>
      </FlexBox>

      <DrawerBox
        minWidth={500}
        selectedDrawerId="workflow-tasks"
        anchor="right"
        onClose={() => {}}
      >
        <WorkflowTaskShort closeDrawer={closeDrawer} />
      </DrawerBox>
    </>
  );
};

export default WorkflowTaskNotifications;
